<template>
    <section v-if="!isShopUser">
        <h2 class="h2 mt-5">Dane związane z rozliczeniami</h2>
        <p class="page-lead mb-3">
            W tej sekcji możesz sprawdzić poprawność danych dotyczących Twoich
            rozliczeń.
        </p>

        <accordion
            v-for="(company, idx) in userCompaniesData"
            class="cux-exclude"
            :key="idx"
            :is-active="expandedIdx === company.id"
            @header-click="onItemToggle(company.id)"
        >
            <template #header>
                {{ company.name }}
            </template>

            <template #body>
                <div class="row" v-if="userData && userDataStatus === 'idle'">
                    <div class="col-md-6 mb-4 mb-md-0">
                        <div class="card p-4">
                            <h2 class="h6">Dane rozliczeniowe</h2>
                            <p class="text-sm mb-4">
                                Dane do faktury i księgowości
                            </p>
                            <the-form
                                :form-fields="billingDataForm(company)"
                            />
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="card min-h-0 p-4">
                            <h2 class="h6 mb-4">Numer rachunku</h2>
                            <the-form
                                :form-fields="billingAccountForm(company)"
                            />
                        </div>
                    </div>
                </div>
            </template>
        </accordion>
    </section>
</template>

<script>
export default {
    name: 'BillingDocumentsManagement',
    data() {
        return {
            user: {
                name: '',
                surname: ''
            },
            expandedIdx: -1
        }
    },
    computed: {
        isShopUser() {
            return this.$store.getters.isShopUser
        },
        userData() {
            return this.$store.getters.getUser
        },
        userCompaniesData() {
            return this.$store.getters.getUserCompaniesData
        },
        userDataStatus() {
            return this.$store.getters.getUserStatus
        }
    },
    methods: {
        formatBankAccount(value) {
            return value.replace(/.{1,2}(?=(.{4})+$)/g, '$& ')
        },
        onItemToggle(companiesId) {
            this.expandedIdx =
                this.expandedIdx === companiesId ? -1 : companiesId
        },
        chevronConfig(companiesId) {
            return {
                down: this.expandedIdx !== companiesId,
                up: this.expandedIdx === companiesId
            }
        },
        billingDataForm(companiesData) {
            return [
                {
                    name: 'mp-billing-name',
                    title: 'Imię',
                    disabled: true,
                    text: `${this.userData.name} ${this.userData.surname}`
                },
                {
                    name: 'mp-billing-company',
                    title: 'Nazwa firmy',
                    disabled: true,
                    text: `${companiesData.name || '-'}`
                },
                {
                    name: 'mp-billing-nip',
                    title: 'NIP',
                    disabled: true,
                    text: `${companiesData.nip || '-'}`
                },
                {
                    name: 'mp-billing-street',
                    title: 'Ulica',
                    disabled: true,
                    text: `${companiesData.street || '-'}`
                },
                {
                    name: 'mp-billing-building',
                    title: 'Numer budynku / lokalu',
                    disabled: true,
                    text: `${companiesData.building || '-'}`
                },
                {
                    name: 'mp-billing-zip',
                    title: 'Kod pocztowy',
                    disabled: true,
                    text: `${companiesData.postalCode || '-'}`,
                    class: 'col-6'
                },
                {
                    name: 'mp-billing-city',
                    title: 'Miejscowość',
                    disabled: true,
                    text: `${companiesData.city || '-'}`,
                    class: 'col-6'
                }
            ]
        },
        billingAccountForm(companiesData) {
            return [
                {
                    name: 'mp-billing-account',
                    title: 'Numer rachunku',
                    disabled: true,
                    text: `${this.formatBankAccount(companiesData.bankAccount.number) || '-'}`
                }
            ]
        }
    },
    created() {
        if (this.userCompaniesData && this.userCompaniesData.length === 1) {
            this.expandedIdx = this.userCompaniesData[0].id
        }
    }
}
</script>
